import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddressDialogCloseEvent, UserSchema, UserService, AuthService } from 'src/app/core';
import { City, iranPhoneValidator, Province } from 'src/app/shared';
import { ShoppingCartService } from 'src/app/feature/payment/services';

@Component({
  templateUrl: './address-add.component.html',
  styleUrls: ['./address-add.component.scss'],
})
export class AddressAddComponent implements OnInit {
  public user!: UserSchema;
  public form!: FormGroup;

  public cities: City[] = [];
  public provinces: Province[] = [];

  constructor(
    private dialogReference: MatDialogRef<AddressAddComponent>,
    @Inject(FormBuilder) public formBuilder: FormBuilder,
    private shoppingCartService: ShoppingCartService,
    @Inject(MAT_DIALOG_DATA) public dialogData: { isNew: boolean; model: any },
    private userService: UserService,
    private authService: AuthService,
  ) {
    dialogData.model = dialogData.model || {};
  }

  async ngOnInit(): Promise<void> {
    this.form = this.formBuilder.group({
      city: [null, Validators.required],
      address: [null, Validators.required],
      province: [null, Validators.required],
      recipientName: [null, Validators.required],
      phoneNumber: [
        null,
        [
          Validators.required,
          iranPhoneValidator,
          Validators.pattern(/[0-9]/gm),
        ],
      ],
      postalCode: [
        null,
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/[0-9]/gm),
        ],
      ],
      landlinePhone: [
        null,
        [
          Validators.required,
          //  Validators.minLength(10), Validators.maxLength(10), // not a goog phone number validator considering changing the lenght of phone numbers
          Validators.pattern(/[0-9]/gm),
        ],
      ],
    });

    this.shoppingCartService.getProvinces().then((provinces: Province[]) => {
      this.provinces = provinces;
    });

    // this.userService
    //   .getUser()
    //   .then((user) => {
    //     this.user = user;
    //   })
    //   .catch((err) => {});
    this.authService.userProfile?.subscribe((userProfile) => {
      this.user = userProfile;
    });
  }

  async updateCities(event: any) {
    const name = event.value;
    const result = this.provinces
      .filter((province) => {
        return province.name === name;
      })
      .at(0);

    this.cities = result?.cities!;
  }

  async addAddressSubmit() {
    var event: any = null;
    if (this.dialogData?.isNew) {
      event = this.generateEvent('address-add', this.form.value);
    } else {
      event = this.generateEvent('address-update', this.form.value);
      event.data.id = this.dialogData.model.id ?? 0;
    }
    this.dialogReference.close(event);
  }

  isValid() {
    return this.form.valid;
  }

  close() {
    const closeEv = this.generateEvent('close');
    this.dialogReference.close(closeEv);
  }

  private generateEvent(
    name: AddressDialogCloseEvent['name'],
    data?: any
  ): AddressDialogCloseEvent {
    return { name, data };
  }
}
